<template>
  <fragment>
    <AppBody
      title="Vendas / Cupons de Desconto"
      :subtitle="pageSubtitle"
      :actions="pageActions"
    >
      <v-form @submit.prevent="filterCupom" class="search-forms">
        <v-row>
          <v-col cols="3">
            <label class="input-labels"> Código do Cupom </label>
            <v-text-field
              solo
              placeholder="Insira o código"
              v-model="$cupom_desconto.filter.codigo"
              type="text"
              data-cy="codigo"
              class="textinput"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels"> Data de Validade (início) </label>
            <v-text-field
              solo
              placeholder="dd/mm/aaaa"
              v-model="$cupom_desconto.filter.dthr_val_ini"
              append-icon="mdi-calendar-blank-outline"
              v-mask="'##/##/####'"
              type="text"
              data-cy="data-inicial"
              class="textinput"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <label class="input-labels"> Data de Validade (Fim) </label>
            <v-text-field
              solo
              placeholder="dd/mm/aaaa"
              v-model="$cupom_desconto.filter.dthr_val_fim"
              append-icon="mdi-calendar-blank-outline"
              v-mask="'##/##/####'"
              type="text"
              data-cy="data-final"
              class="textinput"
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="align-self-end ml-auto">
            <v-btn
              height="48"
              data-cy="filtrar"
              class="button btn-size btn-border"
              type="submit"
              :loading="$cupom_desconto.pesquisar_loading"
              >Filtrar</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" v-if="isAdmin">
            <label class="input-labels"> Tipo de Pessoa </label>
            <v-select
              height="48"
              :items="$cupom_desconto.canal_venda"
              item-text="text"
              item-value="value"
              dense
              solo
              data-cy="tipo-pessoa"
              class="textinput"
              v-model="$cupom_desconto.filter.canal_venda"
              placeholder="Selecione o tipo de pessoa"
            ></v-select>
          </v-col>
          <!-- <v-col cols="3">
            <template
              v-if="$cupom_desconto.filter.canal_venda == 'LOJA' && isAdmin"
            >
              <label required class="input-labels"> Loja </label>
              <v-autocomplete
                v-model="$cupom_desconto.filter.loja"
                :items="$loja_gerenciar.lojas"
                solo
                data-cy="loja"
                class="textinput"
                label="Selecione a Loja"
                clearable
                clear-icon="mdi-close-circle-outline"
                :error-messages="$cupom_desconto.filter.error.loja"
                @input="$cupom_desconto.filter.error.loja = []"
                :filter="searchLoja"
                item-text="nome_loja"
                item-value="sequenciador"
                no-data-text="Nenhuma loja encontrada"
              >
                <template v-slot:selection="{ item }">
                  {{ item.nome_loja }}
                </template>
              </v-autocomplete>
            </template>
          </v-col> -->
        </v-row>
      </v-form>
      <v-data-table
        class="table-body"
        no-data-text="Não há registro de cupons para esta loja."
        loading-text="Buscando informações..."
        :loading="$cupom_desconto.cupom_loja_loading"
        :headers="headersCupom"
        :items="tableValues"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Cupons por página:',
        }"
      >
        <template v-slot:item.valor_desconto="{ item }">
          {{ item.valor_desconto | moeda }}
        </template>
        <template v-slot:item.perc_desconto="{ item }">
          {{ item.perc_desconto }} %
        </template>
        <template v-slot:item.actions="{ item, index }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  :loading="item.edit_button_loading"
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    $cupom_desconto.getCupomByID(
                      item.loja,
                      item.idcupom,
                      'edit',
                      index
                    )
                  "
                  class="mr-2"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  @click="
                    $cupom_desconto.remover(
                      item.idcupom,
                      'Deseja realmente excluir este cupom?'
                    )
                  "
                >
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span>Deletar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <ModalConfirmacao
        :textModal="$cupom_desconto.text"
        @callback="$cupom_desconto.funcaoRemover"
      />
    </AppBody>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import CupomMixins from "@/mixins/Cupom.mixins.js";

export default {
  name: "CupomDeDesconto",
  metaInfo: {
    title: "Cupons de Desconto | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Cupons de Desconto | ElevenTickets",
      },
    ],
  },
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
  },
  props: {},
  mixins: [CupomMixins],
  data() {
    return {
      actions: [
        {
          name: "Novo Cupom",
          action: () => this.$cupom_desconto.getCupomByID("", "", "new"),
        },
      ],
      actionsLojista: [
        {
          name: "Novo Cupom",
          action: () => this.$cupom_desconto.getCupomByID("", "", "new"),
        },
      ],
      dayjs: dayjs,
    };
  },
  computed: {
    ...mapGetters(["storeSequencial", "storeInfo"]),
    pageSubtitle() {
      if (this.$cupom_desconto.loja_nome)
        return "Cupons de Desconto - " + this.$cupom_desconto.loja_nome;
      return "Cupons de Desconto";
    },
    pageActions() {
      if (this.$axios.getLocal("oe_user_info").data?.user_type === "admin")
        return this.actions;
      return this.actionsLojista;
    },
    tableValues() {
      return this.$cupom_desconto.cupom_loja;
    },
    getStore() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return this.$axios.getLocal("loja_cupom_selecionada").data;
      else return this.$axios.getLocal("oe_user_info")?.data?.loja;
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
  },
  methods: {
    filterCupom() {
      this.$cupom_desconto.filtroCupom();
    },
    openModal(name, item) {
      this.$cupom_desconto.cadastro.variacoes.variacoes_produtos =
        item.variacoes_produto;
      document.getElementsByClassName(name)[0].style.display = "flex";
    },
    searchLoja(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.nome_loja.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
  },
  watch: {
    "$store.getters.storeSequencial"() {
      this.filterCupom();
    },
  },
  mounted() {
    this.filterCupom();
  },
  destroyed() {
    this.$cupom_desconto.clearFieldsCupom("FILTROS");
  },
};
</script>

<style scoped>
.table-actions {
  height: 67px !important;
  min-height: 67px !important;
}

.produtos-gerenciar-button1 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button2 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  position: relative;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button3 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
